import React, { createContext, useContext, useEffect, useState } from "react";
import i18n, { LANGUAGES, DEFAULT_LANGUAGE } from "../localization/i18n";

const LanguageContext = createContext(null);

const STORAGE_KEY = "bigmarket_language";

function readStoredLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && LANGUAGES[stored] ? stored : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(readStoredLanguage);

  useEffect(() => {
    const meta = LANGUAGES[language];
    i18n.changeLanguage(language);
    document.documentElement.lang = language;
    document.documentElement.dir = meta.isRTL ? "rtl" : "ltr";
    try {
      localStorage.setItem(STORAGE_KEY, language);
    } catch {
      // ignore storage errors (private browsing, etc.)
    }
  }, [language]);

  function setLanguage(code) {
    if (LANGUAGES[code]) setLanguageState(code);
  }

  const value = {
    language,
    setLanguage,
    isRTL: LANGUAGES[language].isRTL,
    languages: LANGUAGES,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
